import React, { useState } from 'react';
import { AlertCircle, X } from 'lucide-react';

export interface BetaAlertProps {
  featureName: string;
  customMessage?: string;
  dismissible?: boolean;
  onDismiss?: () => void;
}

const BetaAlert: React.FC<BetaAlertProps> = ({
  featureName,
  customMessage,
  dismissible = true,
  onDismiss,
}) => {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) return null;

  const handleDismiss = () => {
    setIsDismissed(true);
    onDismiss?.();
  };

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4 flex items-start gap-3">
      <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
      <div className="flex-1">
        <p className="text-sm font-medium text-amber-800">
          {featureName}はベータ版です
        </p>
        <p className="text-xs text-amber-700 mt-1">
          {customMessage || '予期しない動作が発生する可能性があります。フィードバックをお待ちしています。'}
        </p>
      </div>
      {dismissible && (
        <button
          onClick={handleDismiss}
          className="text-amber-600 hover:text-amber-800 transition-colors p-0.5"
          aria-label="閉じる"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};

export default BetaAlert;
